<template>
  <div class="page-header">
    <component :is="hElement" v-text="title" />
  </div>
</template>
<script>
export default {
  name: 'PageHeader',
  props: {
    hSize: {
      type: Number,
      default: 1,
      validator(val) {
        const num = Number(val);
        return num >= 1 && num <= 6;
      },
    },
    title: {
      type: String,
      default: '- page header -',
    },
  },
  data() {
    return {
      sample: {
        hSize: 6,
        title: 'sample page header',
      },
    };
  },
  computed: {
    hElement() {
      return `h${this.hSize || this.sample.hSize}`;
    },
  },
};
</script>
